import axios from 'axios';
import { isValidToken } from '../utils/jwt';
import useAuth from 'src/hooks/useAuth';
import { toast } from 'sonner';
import { useToast } from 'src/@/components/ui/use-toast';




// Configuração global de interceptors
const setupAxiosInterceptors = () => {

    const { logout } = useAuth();
    const {toast} = useToast()

    const showErrorToast = (message) => {
        toast({
          variant: "destructive",
          title: "Erro",
          description: message,
        });
      };

  axios.interceptors.request.use(
    async (config) => {
      // Pega o token do localStorage
      const token = localStorage.getItem('token');
      
      // Verifica se o token existe e se está expirado
      if (token) {
        if (!isValidToken(token)) {
          // Token expirado
          //alert('Token expirado');
          logout()
          showErrorToast('Sua sessão expirou, faça login novamente')
          return 
        //   localStorage.removeItem('token');
        //   window.location.href = '/login';
        //   return Promise.reject('Token expirado');
        } else {
          // Token válido, adicione ao cabeçalho
          //config.headers.Authorization = `Bearer ${token}`;
        }
      }
      
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;